import React, { useEffect, useState, useMemo } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  Typography,
  InputLabel,
} from "@mui/material";
import {
  fetchAllDistrict,
  fetchAllMunicipality,
  fetchAllVillages,
} from "../action";
import { useDispatch, useSelector } from "react-redux";
import { decodeId, parseData } from "../utils/helper";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Content = styled(Typography)`
  margin-bottom: 0.5rem;
`;
const VillagePicker = ({
  input,
  value,
  reset,
  userHealthFacilityFullPath,
  withLabel = true,
  label = null,
  required = false,
  allRegions,
  municipality,
  error,
  meta,
  ...props
}) => {
  const [selectedValue, setSelectedValue] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (municipality?.municipality)
      dispatch(fetchAllVillages(municipality?.municipality));
  }, [municipality]);
  // }, [allRegions, dispatch]);

  const handleChange = (event) => {
    const selectedRegion = event.target.value;
    setSelectedValue(selectedRegion);
  };

  const regionData = useSelector(
    (state) => state?.profileReducer?.locationVillageResponseData
  );

  return (
    <>
      <Content>
        <Typography required={required} color="#666666">
          {label} {required ? "*" : ""}
        </Typography>
      </Content>
      <FormControl fullWidth>
        <Select
          value={value}
          onChange={handleChange}
          displayEmpty
          required={required}
          size="small"
          error={meta && meta.touched && meta.error && error}
          {...input}
          {...props}
        >
          <MenuItem disabled value="">
            <em>{t("Select")}</em>
          </MenuItem>
          {regionData &&
            regionData.map((region) => (
              <MenuItem key={region.id} value={region.id}>
                {region.name}
              </MenuItem>
            ))}
        </Select>
        {meta && meta.touched && meta.error ? (
          <Typography color="red" fontSize={".8rem"} align={"center"}>
            {error}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    </>
  );
};

export default VillagePicker;
